import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import styled from 'styled-components';
const Wrapper = styled.div `
  margin: auto auto;
  //padding: 45px 106px 0 106px;
  width: 99vw;
  height: 99vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  //&::-webkit-scrollbar {
  //  width: 0;
  //}
`;
export const Container = ({ children }) => _jsx(Wrapper, { children: children });
